import React, { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { InfluencerView } from '@/components/influencer/InfluencerView';
import { AdminInfluencerView } from '@/components/influencer/AdminInfluencerView';
import { useInfluencerStore } from '@/stores/influencerStore';
import toast from 'react-hot-toast';

export const InfluencerPage: React.FC = () => {
  const { user } = useAuth();
  const { 
    fetchDashboardData, 
    fetchInfluencerAnalytics, 
    loading 
  } = useInfluencerStore();

  useEffect(() => {
    const initializeData = async () => {
      try {
        if (user?.role === 'influencer') {
          await fetchDashboardData();
        } else if (['admin', 'super admin'].includes(user?.role || '')) {
          await fetchInfluencerAnalytics();
        }
      } catch (error: any) {
        console.error('Error initializing influencer data:', error);
        const errorMessage = error.response?.data?.error || 'Failed to load influencer data';
        toast.error(errorMessage);
      }
    };

    if (user) {
      initializeData();
    }
  }, [user, fetchDashboardData, fetchInfluencerAnalytics]);

  // Show loading state
  if (loading.dashboard || loading.analytics) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Role-based component rendering
  if (user?.role === 'influencer') {
    return <InfluencerView />;
  } else if (['admin', 'super admin'].includes(user?.role || '')) {
    return <AdminInfluencerView />;
  }

  // Fallback for unauthorized users
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-medium text-gray-900">Access Denied</h3>
      <p className="mt-2 text-sm text-gray-500">
        You don't have permission to access the influencer dashboard.
      </p>
    </div>
  );
}; 